/**
 * Updates Recharge subscription widget when the theme variant changes.
 * - Syncs variant ID to all product form inputs so Recharge (and add-to-cart) see the new variant.
 * - Updates Recharge widget (default-variant-id, prices) and dispatches events so subscribe options refresh.
 */
(function () {
  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updatePricesInRoot(root, priceStr) {
    if (!root) return;
    var selector = '.rc-price, .rc-purchase-option__discounted-price, .rc-purchase-option__price, [part="rc-purchase-option__discounted-price"], [part="rc-purchase-option__price"]';
    try {
      root.querySelectorAll(selector).forEach(function (el) {
        if (el.querySelector && el.querySelector('.rc-price, .rc-purchase-option__discounted-price, .rc-purchase-option__price')) return;
        el.textContent = priceStr;
      });
    } catch (e) {}
  }

  /** Sync variant ID to every product form input so Recharge and add-to-cart form stay in sync */
  function syncVariantInputs(variant) {
    if (!variant || variant.id == null) return;
    var variantId = String(variant.id);
    var productForms = document.querySelectorAll('form[data-type="add-to-cart-form"], form[action*="cart/add"], form[data-productid]');
    if (!productForms.length) {
      var addToCartForm = document.querySelector('product-form form');
      if (addToCartForm) productForms = [addToCartForm];
    }
    productForms.forEach(function (form) {
      var input = form.querySelector('input[name="id"]');
      var select = form.querySelector('select[name="id"]');
      if (input && input.value !== variantId) {
        input.value = variantId;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (select && select.value !== variantId) {
        select.value = variantId;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function updateRechargeWidgetPrices(variant) {
    if (!variant || typeof variant.price !== 'number') return;
    var priceStr = formatPrice(variant.price);

    var wrapper = document.querySelector('.recharge-widget-wrapper') || document.querySelector('[id^="RechargeWidget_"]');
    if (wrapper) {
      updatePricesInRoot(wrapper, priceStr);
    }

    var customWidget = document.querySelector('recharge-subscription-widget');
    if (customWidget) {
      customWidget.setAttribute('default-variant-id', String(variant.id));
      updatePricesInRoot(customWidget, priceStr);
      if (customWidget.shadowRoot) {
        updatePricesInRoot(customWidget.shadowRoot, priceStr);
        customWidget.shadowRoot.querySelectorAll('*').forEach(function (node) {
          if (node.shadowRoot) updatePricesInRoot(node.shadowRoot, priceStr);
        });
      }
      document.dispatchEvent(new CustomEvent('recharge:variantChange', { detail: { variantId: variant.id, variant: variant } }));
      if (typeof customWidget.setVariantId === 'function') {
        customWidget.setVariantId(variant.id);
      }
      if (typeof customWidget.refresh === 'function') {
        customWidget.refresh();
      }
    }
  }

  function onVariantChange(event) {
    if (!event.data || !event.data.variant) return;
    var variant = event.data.variant;
    syncVariantInputs(variant);
    updateRechargeWidgetPrices(variant);
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(init, 50);
      return;
    }
    subscribe(PUB_SUB_EVENTS.variantChangeImmediate, onVariantChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
